import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  question: 'Is this safe if I have high blood pressure?',
  answer: 'Yes! The ingredients are all-natural food items. However, always consult your doctor first.'
}, {
  question: 'Is it easy to follow?',
  answer: 'Yes! It’s designed for busy women. The main ritual takes only 5 minutes.'
}, {
  question: 'How soon will I get the book?',
  answer: 'Instantly. As soon as you complete your order, it will be in your inbox.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-white" data-id="element-54">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl" data-id="element-55">
        <h2 className="text-3xl font-bold text-center text-stone-900 mb-12" data-id="element-56">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-57">
          {faqs.map((faq, index) => <div key={index} className="border border-stone-200 rounded-lg overflow-hidden" data-id="element-58">
              <button className="w-full flex items-center justify-between p-6 text-left bg-stone-50 hover:bg-stone-100 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-59">
                <span className="font-bold text-stone-900 text-lg" data-id="element-60">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-stone-500" data-id="element-61" /> : <ChevronDown className="w-5 h-5 text-stone-500" data-id="element-62" />}
              </button>

              {openIndex === index && <div className="p-6 bg-white border-t border-stone-200" data-id="element-63">
                  <p className="text-stone-600" data-id="element-64">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}